import { render, staticRenderFns } from "./highlighted-image-cmp.vue?vue&type=template&id=3b9bdefd&scoped=true&functional=true"
import script from "./highlighted-image-cmp.vue?vue&type=script&lang=js"
export * from "./highlighted-image-cmp.vue?vue&type=script&lang=js"
import style0 from "./highlighted-image-cmp.vue?vue&type=style&index=0&id=3b9bdefd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3b9bdefd",
  null
  
)

export default component.exports